export default __webpack_public_path__ + "static/media/rnr-sports-table-12.48e06e5a.webp";